module.exports = __webpack_public_path__ + "static/media/Football Frenzy2.ebee2777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images/Football Frenzy2.jpg
// module id = 672
// module chunks = 0